import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

let warned = false;

function makeStub() {
	const warn = (method: string) => {
		if (!warned) {
			console.warn('[Supabase] Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY. Using stub client. All calls will be no-ops.');
			warned = true;
		}
		return new Error(`Supabase unavailable (stub) at ${method}`);
	};

	const stubAuth = {
		getSession: async () => ({ data: { session: null }, error: warn('auth.getSession') }),
		onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
		signInWithOtp: async () => ({ data: { user: null, session: null }, error: warn('auth.signInWithOtp') }),
		signInWithPassword: async () => ({ data: { user: null, session: null }, error: warn('auth.signInWithPassword') }),
		signUp: async () => ({ data: { user: null, session: null }, error: warn('auth.signUp') }),
		updateUser: async () => ({ data: { user: null }, error: warn('auth.updateUser') }),
		getUser: async () => ({ data: { user: null }, error: warn('auth.getUser') }),
		signOut: async () => ({ error: warn('auth.signOut') })
	};

	const stubQuery = () => {
		const chain = {
			select: async () => ({ data: [], error: warn('from.select') }),
			insert: async () => ({ data: null, error: warn('from.insert') }),
			update: async () => ({ data: null, error: warn('from.update') }),
			delete: async () => ({ data: null, error: warn('from.delete') }),
			maybeSingle: async () => ({ data: null, error: warn('from.maybeSingle') }),
			order: () => chain,
			eq: () => chain,
			in: () => chain,
			limit: () => chain
		};
		return chain;
	};

	return { auth: stubAuth, from: stubQuery } as any;
}

export const supabase = (!supabaseUrl || !supabaseAnonKey)
	? makeStub()
	: createClient(supabaseUrl, supabaseAnonKey);

